module.exports = __webpack_public_path__ + "c2c8a8463c284433e6afdf8366366574.ttf";